module.exports = __webpack_public_path__ + "images/external_images/img/235x486/img2.png";